import React from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import img1 from '../assets/images/mockup_TranparentBG.png'
import ListMasjidSection from '../components/ListMasjidSection/ListMasjidSection';
import { Link } from 'react-router-dom';
import './senaraiInstitusi.scss'

function SenaraiInstitusi(props) {
    const url = process.env.NODE_ENV === 'production' ? 'https://cp.al-jariyah.com/register' : 'https://cpdemo-kariah.al-jariyah.com/register'
    return (
        <div className='page-explore'>
            {/* <PageTitle sub='Explore' title='Senarai Institusi' /> */}
            <section className="si-hero">
                <div className="tf-container">
                    <div className="si-hero-inner">
                        <div className="si-hero-content">
                            <span className="si-hero-eyebrow">Al-Jariyah</span>
                            <h2 className="si-hero-title">Jom Sertai Kami</h2>
                            <p className="si-hero-desc">Daftarkan institusi anda dan jadi sebahagian daripada perintis Al-Jariyah.</p>
                            <Link to={url} target='_blank' className="si-hero-cta">
                                Sertai Kami
                                <i className="fas fa-arrow-right"></i>
                            </Link>
                        </div>
                        <div className="si-hero-media">
                            <img src={img1} alt="AlJariyah" />
                        </div>
                    </div>
                </div>
            </section>

            <ListMasjidSection  />
            
        </div>
    );
}

export default SenaraiInstitusi;